import { configureStore } from "@reduxjs/toolkit";

import AuthScreen from './reducer/auth'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from "redux-persist";
import { combineReducers, } from "@reduxjs/toolkit";
import { encryptTransform } from "redux-persist-transform-encrypt";


const encryptor = encryptTransform({
    secretKey: "67*&DD@~101@#1997#%3008.h",
    onError: function (error) {
        console.error("Encryption Error:", error);
    },
});


const persistConfig = {
    key: 'root5',
    version: 1,
    transforms: [encryptor],
    storage
}

const rootReducer = combineReducers({
    AuthPage: AuthScreen,
})

const persitedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persitedReducer
})